import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51cda3a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex-shrink-0" }
const _hoisted_3 = { class: "ml-3" }
const _hoisted_4 = { class: "ml-auto pl-3" }
const _hoisted_5 = { class: "-mx-1.5 -my-1.5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Dismiss", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExclamationCircleIcon = _resolveComponent("ExclamationCircleIcon")!
  const _component_XIcon = _resolveComponent("XIcon")!

  return (_openBlock(), _createBlock(_Transition, {
    "enter-active-class": "transform ease-out duration-300 transition",
    "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
    "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
    "leave-active-class": "transition ease-in duration-100",
    "leave-from-class": "opacity-100",
    "leave-to-class": "opacity-0"
  }, {
    default: _withCtx(() => [
      ($props.isOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: {"z-index":"999998"},
            class: _normalizeClass(["rounded-md p-4 fixed _alert", 
				$props.type === 'danger' || $props.type === 'error'
					? 'bg-sienna-100'
					: 'bg-green-50'
			])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_ExclamationCircleIcon, {
                  class: _normalizeClass(["h-5 w-5", 
							$props.type === 'danger' || $props.type === 'error'
								? 'text-sienna-600'
								: 'text-green-400'
						]),
                  "aria-hidden": "true"
                }, null, 8, ["class"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("p", {
                  class: _normalizeClass(["text-sm font-medium", 
							$props.type === 'danger' || $props.type === 'error'
								? 'text-sienna-600'
								: 'text-green-800'
						])
                }, [
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["inline-flex rounded-md p-1.5 hover:bg-green-100", 
								$props.type === 'danger' || $props.type === 'error'
									? 'bg-sienna-100 text-sienna-600 hover:bg-sienna-200'
									: 'bg-green-50 text-green-500'
							])
                  }, [
                    _hoisted_6,
                    _createVNode(_component_XIcon, {
                      class: "h-5 w-5",
                      "aria-hidden": "true",
                      onClick: $setup.setAlert
                    }, null, 8, ["onClick"])
                  ], 2)
                ])
              ])
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}